import api from "./api";

export async function getMe({ silent = false } = {}) {
  const requestConfig = silent ? { skipErrorNotification: true } : {};
  const { data: user } = await api.get("/api/v1/users/me", requestConfig);
  const { data: divisions } = await api.get("/api/v1/divisions", {
    params: { divisionIds: user.divisionIds, eons: true },
    limit: 100,
    ...(silent ? { skipErrorNotification: true } : {}),
  });
  user.divisions = divisions.data;
  return user;
}

export async function login(loginData) {
  const resp = await api.post("/api/v1/users/login", loginData);
  return resp.data;
}

export async function logout() {
  const resp = await api.post("/api/v1/users/logout", null, {
    skipErrorNotification: true,
  });
  return resp.data;
}

export async function loginSSO(loginData) {
  const resp = await api.post("/api/v1/users/loginSSO", loginData);
  return resp.data;
}
